module.exports = __webpack_public_path__ + "media/images/calendar/may-a223e1c9be8507e44978dd044cf665a1.jpg";